import { ModalActionKind } from './reducer';
/**
 * Handles actions related to modals, should be used for modals that we expect to display
 * from multiple places in the app
 * @param state - Gets passed in by dispatch, the current state of the reducer.
 * @param action - One of the specified actions to act upon.
 * @returns {ModalState} - New state after the action effect is applied.
 */
export const modalReducer = (state, action) => {
    console.log('test 1');
    switch (action.type) {
        case ModalActionKind.OpenAddBooking:
            return {
                ...state,
                isAddBookingModalOpen: true,
                addBookingModalDate: action.payload,
            };
        case ModalActionKind.CloseAddBooking:
            return {
                ...state,
                isAddBookingModalOpen: false,
            };
        case ModalActionKind.OpenBookingSummary:
            return {
                ...state,
                isBookingSummaryOpen: true,
                bookingSummaryDays: action.payload,
            };
        case ModalActionKind.CloseBookingSummary:
            return {
                ...state,
                isBookingSummaryOpen: false,
                bookingSummaryDays: [],
            };
        case ModalActionKind.OpenPromptAddAbsence:
            console.log('test 2');
            return {
                ...state,
                isPromptAddAbsenceOpen: true,
                addBookingModalDate: action.payload,
            };
        case ModalActionKind.ClosePromptAddAbsence:
            return {
                ...state,
                isPromptAddAbsenceOpen: false,
            };
        default:
            return state;
    }
};
